<div class="popup-wrapper">
    <div class="popup-header">
        <span class="divisions-icon nav-icon "
            style="width: 20px; height: 20px; background-color: var(--soc-cyan);"></span>
        <span class="soc-panel-h">{{(editFlag ? 'DIVISION.EDIT_DIVISION' : "DIVISION.NEW_DIVISION") | translate}}</span>
    </div>
    <hr class="soc-panel-line">
    <form #f="ngForm" class="soc-form-wrapper-gap-24">
        <div class="soc-input-wrapper">
            <label for="name" class="soc-input-lbl w-100 text-start">{{'DIVISION.DIVISION_NAME'| translate}}</label>
            <div class="soc-error-field-wrapper">
                <span *ngIf="name.invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                <input [ngClass]="{'soc-error-active': name.invalid && f.submitted}" required name="name" #name="ngModel" type="text" class="soc-input-field soc-input-text" placeholder="{{'TYPE_HERE' | translate}}" [(ngModel)]="division.name">
            </div>
        </div>
        <div class="soc-input-wrapper">
            <label for="printerAddress" class="soc-input-lbl w-100 text-start">{{'DIVISION.IP_ADDRESS'| translate}}</label>
            <div class="soc-error-field-wrapper">
                <span *ngIf="printerAddress.invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                <input [ngClass]="{'soc-error-active': printerAddress.invalid && f.submitted}" required name="printerAddress" #printerAddress="ngModel" class="soc-input-field soc-input-text" placeholder="{{'TYPE_HERE' | translate}}" [(ngModel)]="division.printerAddress">
            </div>
        </div>
        <div  class="soc-input-wrapper">
            <label for="invenotry" class="soc-input-lbl w-100 text-start">{{'DIVISION.INVENTORY' | translate}}</label>
            <div class="soc-error-field-wrapper">
                <span *ngIf="invId.invalid && f.submitted"  pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}"  tooltipPosition="top" class="material-icons soc-error-icon" >info</span>
                <p-dropdown appendTo="body" [autoDisplayFirst]="false"
                [options]="inventories" optionLabel="name" [(ngModel)]="division.inventory"
                placeholder="{{'SELECT.INVENTORY' | translate }}" filterPlaceholder="{{'SEARCH' | translate }}"
                 [ngClass]="{'soc-error-active-dropdown': invId.invalid && f.submitted}" [required]="true" name="invId" #invId="ngModel" class="soc-dropdown soc-dropdown-search-separator" [virtualScroll]="true" [filter]="true" [showClear]="true" filterPlaceholder="{{'SEARCH' | translate}}"></p-dropdown>
            </div>
        </div>
        <hr class="soc-panel-line">
        <div class="soc-wrapper-gap-12 d-flex justify-content-end">
            <button class="soc-secondary-grey-btn" type="button" (click)="close()">{{'CANCEL'| translate}}</button>
            <button class="soc-basic-cyan-btn" type="submit"
                (click)="editFlag ? editDivision(f) : addDivision(f) ">{{(editFlag ?
                'SAVE_CHANGES' : 'CREATE')| translate}}</button>
        </div>
    </form>
</div>